export enum NotificationRole {
    GEOFENCE = "117b710a-9a00-468c-b9d6-c9fe3912afa4",
    ROUTE_DETOUR = "HpmVXasg6hKj20QODniu",
    PANIC = "18cd0760-8bbb-470f-93a1-551d25770941",
    GPS_TRACKING_ALERT = "4Do8XamMS2seYzgN4gWB"
}

export enum NotificationTypes {
    NEGOTIATION = '1',
    TRACKING = '2',
    DELAY_BETWEEN_POINTS = '3',
    CREATE_CARGO = '4',
    USER_DEACTIVATE = '5',
    GEOFENCE = '6',
    PANIC = '7',
    GPS_OFF = '8',
    ANTENNA = '9',
    VEHICLE_OFF = '10',
    LOW_BATTERY = '11',
    OPENED_DOOR = '12',
    DEFAULT_ALERT = '13',
    TIME_REPORT_ALERT = '14',
    HARD_BRAKING = '15',
    SUDDEN_TURN = '16',
    SUDDEN_ACCELERATION = '17',
    GPS_TRACKING_ALERT = '18',
    ROUTE_DETOUR = '19',
}
